"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const actions_1 = require("../context/actions");
const constants_1 = require("../data/constants");
const math_1 = require("./math");
const setFiatValue = (dispatch, selectedFiat, baseFiatRate) => {
    if (selectedFiat !== "USD" && baseFiatRate) {
        const convertedBaseRate = Math.round(constants_1.DEFAULT_FIAT_AMOUNT * baseFiatRate);
        const rounded = (0, math_1.roundUp)(convertedBaseRate, Math.pow(10, (convertedBaseRate.toString().length - 1)));
        dispatch({ type: actions_1.CONTEXT_ACTIONS.SET_FIAT_VALUE, payload: rounded });
    }
    else if (selectedFiat === "USD") {
        dispatch({
            type: actions_1.CONTEXT_ACTIONS.SET_FIAT_VALUE,
            payload: constants_1.DEFAULT_FIAT_AMOUNT,
        });
    }
};
exports.default = setFiatValue;
//# sourceMappingURL=setFiatValue.js.map